import { ArrowRight, Star } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Link } from "@tanstack/react-router";

export default function VendorProfile({ vendor }: { vendor: any }) {
	return (
		<div className=" w-full flex items-center justify-between p-4 bg-white rounded-lg">
			<div className="flex items-center gap-4">
				<img
					src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Screenshot%202025-02-24%20at%2019.24.08-MRtnsWRBCEeZlySIuU8hUGxbFw07ki.png"
					alt="Vendor profile"
					width={56}
					height={56}
					className="rounded-full object-cover"
				/>
				<div className="space-y-1">
					<h2 className="font-semibold text-lg">{vendor.fullName}</h2>
					<p className="text-sm text-muted-foreground">{`Location: ${vendor?.address ?? ""}`}</p>
				</div>
			</div>

			<div className="flex items-center gap-8">
				<div className="flex flex-col items-end gap-2">
					<div className="flex items-center gap-1">
						{[...Array.from({ length: 5 })].map((_, i) => (
							<Star
								key={crypto.randomUUID()}
								className={`w-5 h-5 ${i < 4 ? "fill-primary text-primary" : "fill-muted text-muted-foreground"}`}
							/>
						))}
						<span className="ml-2 text-sm font-medium">4.0</span>
					</div>
					<div className="flex items-center -space-x-2">
						{[...Array.from({ length: 6 })].map((_, i) => (
							<div key={crypto.randomUUID()} className="w-8 h-8 rounded-full border-2 border-white overflow-hidden">
								<img
									src="/placeholder.svg"
									alt={`Reviewer ${i + 1}`}
									width={32}
									height={32}
									className="w-full h-full object-cover"
								/>
							</div>
						))}
						<div className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-xs font-medium ml-1">
							+57
						</div>
					</div>
				</div>

				<Button variant="link" className="text-primary font-medium" asChild>
					<Link to="/buyer/vendor/$vendorid" params={{ vendorid: vendor.id }}>
						<span>See this vendor's Profile</span>
						<ArrowRight className="w-4 h-4 ml-2" />
					</Link>
				</Button>
			</div>
		</div>
	);
}

export function RecentlyViewed({ vendors, isLoading }: { vendors: any[]; isLoading?: boolean }) {
	return (
		<div className="space-y-6 bg-white rounded-lg p-6 min-h-[40vh]">
			<div className="flex items-center justify-between">
				<h2 className="text-xl font-semibold">Recently viewed</h2>
				<Button variant="link" className="text-primary font-medium">View all</Button>
			</div>
			<div className="flex flex-col items-center justify-center">
				{

					isLoading
						? (
								<div className="flex flex-col items-center justify-center gap-4">
									<div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
									<p className="text-muted-foreground">Loading...</p>
								</div>
							)
						: vendors.length
							? vendors.map(vendor => (
									<VendorProfile key={vendor.id + crypto.randomUUID()} vendor={vendor.vendor} />
								))
							: (
									<div className="flex flex-col items-center">
										<div className="mb-4 rounded-full bg-purple-100 p-6">
											<img src="/assets/shop.png" alt="shop-image" />
										</div>
										<h3 className="mb-2 text-xl font-semibold">You've not searched any vendors yet</h3>
										<p className="text-center text-muted-foreground font-thin">
											All the vendors you searched recently will appear here
										</p>
									</div>
								)
				}
			</div>
		</div>
	);
}
